import { TwinTableLink } from '../../../../../baseComponents/TwinTable'
import { TableComponentBaseScreenInnerProps } from '../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { addDictionaryExtraLine } from '../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import { DisplayPriceGettingParams } from '../../../../../baseComponents/Displays/DisplayPrice'
import { CustomRenderDate, CustomRenderString } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import locations from '../../../../../utils/globals/locations'
import { SellTicketModelType } from '@teinor/erp/types/company/order/sell/sellTicket'
import useSellTicketStatusType from '../../../../../utils/hooks/sells/orders/useSellTicketStatus'
import { useMemo } from 'react'
import { getEmployees } from '../../../../../utils/reducers/getters'
import { sortEmployeesByUser } from '../../../../../utils/globals/employees'
import { RenderSellTicketStatus } from '../../../../inputTableLayouts/order/OrderSellTicketTPVLayout/components/RenderSellTicketStatus'

type TableCustomerTicketsProps = TableComponentBaseScreenInnerProps & {}

const TableCustomerTickets: React.FC<TableCustomerTicketsProps> = ({ setOpened, setTableInstance, extraWhereParams, ...rest }) => {
    const { t } = useTwinTranslation()
    const { sellTicketStatus } = useSellTicketStatusType()
    const memoEmployees = useMemo(() => addDictionaryExtraLine(JSON.parse(JSON.stringify(getEmployees() || {}))), [])
    const columns: ColumnTableSchema<SellTicketModelType> = [
        {
            id: 'full_assigned_number',
            dataKey: 'full_assigned_number',
            label: t('ticket', 'Ticket'),
            sortable: true,
            customRender: (parameterValue, allRowData) => <CustomRenderString value={parameterValue} className={allRowData?.assigned_number ? '' : 'text-red-BA'} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('ticket', 'Ticket') }
            },
        },
        {
            id: 'status',
            dataKey: 'status',
            searchKey: 'SellTicket.status',
            label: t('status', 'Estado'),
            sortable: true,
            minWidth: 135,
            customRender: (parameterValue) => <RenderSellTicketStatus value={parameterValue} />,
            searchableComponent: {
                component: 'SearchableComponentsCustomSelect',
                extraComponentData: { items: sellTicketStatus, label: t('statusTicket', 'Estado del ticket') }
            },
        },
        {
            id: 'WorkingCenterId',
            dataKey: 'WorkingCenterId',
            searchKey: 'WorkingCenter.name',
            label: t('soldBy', 'Vendido por'),
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.WorkingCenter?.name || ''} />,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('workingCenter', 'Centro de trabajo') }
            },
            minWidth: 120
        },
        {
            id: 'processed_date',
            dataKey: 'processed_date',
            label: t('createdDate', 'Fecha de creación'),
            customRender: (parameterValue, allRowData) => <CustomRenderDate value={parameterValue || allRowData.createdAt} className={parameterValue ? '' : 'text-red-BA'} />,
            sortable: true,
            minWidth: 165
        },
        {
            id: 'total_total',
            dataKey: 'total_total',
            label: t('total', 'Total'),
            sortable: true,
            minWidth: 100,
            customRender: (parameterValue, allRowData) => <DisplayPriceGettingParams value={parseFloat(parameterValue)} with_vat={allRowData.with_vat} CurrencyId={allRowData.CurrencyId} />,
        },
        {
            id: 'CreateEmployeeId',
            dataKey: 'CreateEmployeeId',
            label: t('madeBy', 'Realizado por'),
            hideColumnByDefault: true,
            searchKey: 'CreateEmployee.fullname_short',
            customRender: (_parameterValue, allRowData) => {
                const employeeName = allRowData?.CreateEmployee ? allRowData?.CreateEmployee?.fullname_short : allRowData?.ProcessEmployee?.fullname_short
                return <CustomRenderString value={employeeName || ''} />
            },
            searchableComponent: {
                component: 'SearchableComponentsCustomSelectSearchBar',
                extraComponentData: {
                    items: memoEmployees,
                    label: t('madeBy', 'Realizado por'),
                    sortItems: true,
                    sortFunction: sortEmployeesByUser
                }
            },
            searchSingleKey: 'CreateEmployee.id'
        },
        {
            id: 'maxRefundDate',
            dataKey: 'maxRefundDate',
            label: t('maxRefundDateShort', 'Fecha máx. dev.'),
            simpleLabel: t('maxRefundDate', 'Fecha máxima de devolución'),
            customRender: (parameterValue, allRowData) => <CustomRenderDate value={parameterValue || ''} />,
            sortable: true,
            minWidth: 165,
        },
    ]
    return (
        <TwinTableLink createRowDataLink={[locations.sellTicketSingle, ['$id']]} columns={columns} name='customersTickets' getDataFrom='/api/app/order/tpv/sellTicket/getAllSellTicketsComplete'
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData,
            })} setTableInstance={setTableInstance} extraWhereParams={extraWhereParams} {...rest}
        >
        </TwinTableLink>
    )
}

export default TableCustomerTickets